import React from 'react';
import ProfileDetails from './ProfileDetails';
import { useSelector } from "react-redux";

const Profile = () => {
  const activeMerchant = useSelector(({ data }) => data.activeMerchant);

  return (
    <div>
      <ProfileDetails />
      {/*{activeMerchant && Object.keys(activeMerchant).length > 0 && !activeMerchant.enable_affiliate*/}
      {/*  && (*/}
      {/*    <APIKeyCard />*/}
      {/*  )}*/}

      {/* {activeMerchant && Object.keys(activeMerchant).length > 0
        && (
          <APIKeyCard />
        )} */}

    </div>
  )
};

export default Profile;
